module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-85017604.png";